import React, { FC, HTMLAttributes } from "react";
import { Images } from "../../../@assets/images";
import { ElBanner, ElContent, elGapBanner, elGapTitle, ElpoweredImage, ElTitle } from "./locations.css";
import { Container } from "../../layout";
import { elFlexJustifyStart, elFlexNoWrap } from "../../../@css-style";
import { cx } from "@linaria/core";
import { ElHeadLine } from "../head-title";
interface ILocationProps extends HTMLAttributes<HTMLElement> {}

export const Location: FC<ILocationProps> = ({ children, ...props }) => {
  return (
    <ElBanner {...props}>
      <Container className={elGapBanner}>
        <ElContent className={cx(elFlexJustifyStart, elGapTitle)}>
          <ElHeadLine>Targets</ElHeadLine>
        </ElContent>
        <ElContent className={cx(elFlexNoWrap)}>
          <ElpoweredImage src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/map.png' />
          <ElTitle className={elFlexJustifyStart}>
            Sejak 2020, BEKUP (Badan Ekraf for Startup) telah merangkul startup di berbagai wilayah di Indonesia. Inkubasi ini membuka peluang bagi seluruh masyarakat di Indonesia agar pemerataan
            talenta dapat tercapai. Program BEKUP 2025 akan memberikan dampak kepada <b> 550+ startups dan talenta startups</b> yang nanti nya akan dikurasi menjadi 10 early-stage startups terbaik dan
            5 prototype dengan solusi terbaik.
          </ElTitle>
        </ElContent>
      </Container>
    </ElBanner>
  );
};
